import { render, staticRenderFns } from "./devops-customers.vue?vue&type=template&id=16fc64d3&scoped=true"
import script from "./devops-customers.js?vue&type=script&lang=js&external"
export * from "./devops-customers.js?vue&type=script&lang=js&external"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc64d3",
  null
  
)

export default component.exports